/// swap amm sdk

import { Types } from "aptos";

import {
  foil_swap_address,
  foil_vesting_address,
  test_coin_address,
} from "./address";
import {
  get_coin_info,
  getAccountResource,
  getAccountResources,
  getCoinBalance,
  getCoinBalanceNoDecimals,
  getVoteWeight,
  getGaugeId,
  getRewardAmounts,
  getMyVotes,
} from "./aptos_sdk";
import { short_name } from "./coin_list";
import APT_LOGO from "../imgs/coin/APTOS.png";
import coins from "../libs/coins/coins.json";
import {
  Pool,
  getCoinInfo,
  Trade,
  TradeRoute,
  getCoinListFromTradeRoute,
  PoolVote,
  MyRewardInfo,
} from "../libs/pool";

export async function submit(
  signAndSubmitTransaction: Function,
  fun: string,
  type_arguments: any[],
  args: any[]
) {
  const payload: Types.TransactionPayload = {
    type: "entry_function_payload",
    function: fun,
    type_arguments,
    arguments: args,
  };
  window.console.info(payload);
  const transactionRes = await signAndSubmitTransaction(payload);

  window.console.info(transactionRes);
  return transactionRes;
}

export async function mint(fn: Function, coin: string, amount: number) {
  return await submit(
    fn,
    `${test_coin_address}::${coin}::mint_me`,
    [],
    [amount]
  );
}

export async function swap_exact_input(
  fn: Function,
  in_coin: string,
  out_coin: string,
  in_amount: number,
  min_out_amount: number
) {
  return await submit(
    fn,
    `${foil_swap_address}::router::swap_exact_input`,
    [in_coin, out_coin],
    [in_amount, min_out_amount]
  );
}

export async function swap_exact_output(
  fn: Function,
  in_coin: string,
  out_coin: string,
  out_amount: number,
  max_in_amount: number
) {
  return await submit(
    fn,
    `${foil_swap_address}::router::swap_exact_input`,
    [in_coin, out_coin],
    [out_amount, max_in_amount]
  );
}
// X -> Y -> Z
export async function swap_exact_input_doublehop(
  fn: Function,
  x_coin: string,
  y_coin: string,
  z_coin: string,
  in_amount: number,
  min_out_amount: number
) {
  return await submit(
    fn,
    `${foil_swap_address}::router::swap_exact_input_doublehop`,
    [x_coin, y_coin, z_coin],
    [in_amount, min_out_amount]
  );
}
// X -> Y -> Z
export async function swap_exact_output_doublehop(
  fn: Function,
  x_coin: string,
  y_coin: string,
  z_coin: string,
  out_amount: number,
  max_in_amount: number
) {
  return await submit(
    fn,
    `${foil_swap_address}::router::swap_exact_output_doublehop`,
    [x_coin, y_coin, z_coin],
    [out_amount, max_in_amount]
  );
}

// X -> Y -> Z -> A
export async function swap_exact_input_triplehop(
  fn: Function,
  x_coin: string,
  y_coin: string,
  z_coin: string,
  a_coin: string,
  in_amount: number,
  min_out_amount: number
) {
  return await submit(
    fn,
    `${foil_swap_address}::router::swap_exact_input_triplehop`,
    [x_coin, y_coin, z_coin, a_coin],
    [in_amount, min_out_amount]
  );
}

export async function swap_exact_output_triplehop(
  fn: Function,
  x_coin: string,
  y_coin: string,
  z_coin: string,
  a_coin: string,
  out_amount: number,
  max_in_amount: number
) {
  return await submit(
    fn,
    `${foil_swap_address}::router::swap_exact_output_triplehop`,
    [x_coin, y_coin, z_coin, a_coin],
    [out_amount, max_in_amount]
  );
}

//X -> Y -> Z -> A -> B
export async function swap_exact_input_quadruplehop(
  fn: Function,
  x_coin: string,
  y_coin: string,
  z_coin: string,
  a_coin: string,
  b_coin: string,
  in_amount: number,
  min_out_amount: number
) {
  return await submit(
    fn,
    `${foil_swap_address}::router::swap_exact_input_quadruplehop`,
    [x_coin, y_coin, z_coin, a_coin, b_coin],
    [in_amount, min_out_amount]
  );
}

export async function swap_exact_output_quadruplehop(
  fn: Function,
  x_coin: string,
  y_coin: string,
  z_coin: string,
  a_coin: string,
  b_coin: string,
  out_amount: number,
  max_in_amount: number
) {
  return await submit(
    fn,
    `${foil_swap_address}::router::swap_exact_output_quadruplehop`,
    [x_coin, y_coin, z_coin, a_coin, b_coin],
    [out_amount, max_in_amount]
  );
}

export async function swapExactInput(
  fn: Function,
  tradeRoute: TradeRoute,
  in_amount: number,
  min_out_amount: number
) {
  const coinList = getCoinListFromTradeRoute(tradeRoute);

  if (tradeRoute.pools.length === 1) {
    return await swap_exact_input(
      fn,
      coinList[0],
      coinList[1],
      in_amount,
      min_out_amount
    );
  } else if (tradeRoute.pools.length === 2) {
    return await swap_exact_input_doublehop(
      fn,
      coinList[0],
      coinList[1],
      coinList[2],
      in_amount,
      min_out_amount
    );
  } else if (tradeRoute.pools.length === 3) {
    return await swap_exact_input_triplehop(
      fn,
      coinList[0],
      coinList[1],
      coinList[2],
      coinList[3],
      in_amount,
      min_out_amount
    );
  } else if (tradeRoute.pools.length === 4) {
    return await swap_exact_input_quadruplehop(
      fn,
      coinList[0],
      coinList[1],
      coinList[2],
      coinList[3],
      coinList[4],
      in_amount,
      min_out_amount
    );
  }
  return null;
}

export async function swapExactOutput(
  fn: Function,
  tradeRoute: TradeRoute,
  out_amount: number,
  max_in_amount: number
) {
  const coinList = getCoinListFromTradeRoute(tradeRoute);

  if (tradeRoute.pools.length === 1) {
    return await swap_exact_output(
      fn,
      coinList[0],
      coinList[1],
      out_amount,
      max_in_amount
    );
  } else if (tradeRoute.pools.length === 2) {
    return await swap_exact_output_doublehop(
      fn,
      coinList[0],
      coinList[1],
      coinList[2],
      out_amount,
      max_in_amount
    );
  } else if (tradeRoute.pools.length === 3) {
    return await swap_exact_output_triplehop(
      fn,
      coinList[0],
      coinList[1],
      coinList[2],
      coinList[3],
      out_amount,
      max_in_amount
    );
  } else if (tradeRoute.pools.length === 4) {
    return await swap_exact_output_quadruplehop(
      fn,
      coinList[0],
      coinList[1],
      coinList[2],
      coinList[3],
      coinList[4],
      out_amount,
      max_in_amount
    );
  }
  return null;
}

export async function lock_vest(
  fn: Function,
  in_amount: number,
  lock_duration: number
) {
  return await submit(
    fn,
    `${foil_vesting_address}::voting_escrow::create_lock`,
    [],
    [in_amount, lock_duration]
  );
}

export async function increase_amount_vest(
  fn: Function,
  token_id: number,
  in_amount: number
) {
  return await submit(
    fn,
    `${foil_vesting_address}::voting_escrow::increase_amount`,
    [],
    [token_id, in_amount]
  );
}

export async function increase_duration_vest(
  fn: Function,
  token_id: number,
  lock_duration: number
) {
  return await submit(
    fn,
    `${foil_vesting_address}::voting_escrow::increase_unlock_time`,
    [],
    [token_id, lock_duration]
  );
}

export async function withdraw_vest(fn: Function, token_id: number) {
  return await submit(
    fn,
    `${foil_vesting_address}::voting_escrow::withdraw`,
    [],
    [token_id]
  );
}

export async function bribe_claim(
  fn: Function,
  token_id: number,
  bribe_id: number,
  my_reward_infos: MyRewardInfo[]
) {
  const coin_type_infos_str: string[] = my_reward_infos.map(
    (my_reward_info) => my_reward_info.coin_info.address
  );

  if (coin_type_infos_str.length === 1) {
    return await submit(
      fn,
      `${foil_vesting_address}::foil::claim_bribe`,
      coin_type_infos_str,
      [bribe_id, token_id]
    );
  }
  if (coin_type_infos_str.length === 2) {
    return await submit(
      fn,
      `${foil_vesting_address}::foil::claim_bribe2`,
      coin_type_infos_str,
      [bribe_id, token_id]
    );
  }
  if (coin_type_infos_str.length === 3) {
    return await submit(
      fn,
      `${foil_vesting_address}::foil::claim_bribe3`,
      coin_type_infos_str,
      [bribe_id, token_id]
    );
  }
  if (coin_type_infos_str.length === 4) {
    return await submit(
      fn,
      `${foil_vesting_address}::foil::claim_bribe4`,
      coin_type_infos_str,
      [bribe_id, token_id]
    );
  }
}

export async function vote(
  fn: Function,
  token_id: number,
  pool_vote: string[],
  weights: number[]
) {
  const u64_weights: number[] = [];
  const sign_weights: boolean[] = [];
  const filtered_pool_vote: string[] = [];
  weights.map((weight, index) => {
    if (weight !== 0) {
      u64_weights.push(Math.abs(weight));
      sign_weights.push(weight >= 0);
      filtered_pool_vote.push(pool_vote[index]);
    }
  });
  return await submit(
    fn,
    `${foil_vesting_address}::foil::vote`,
    [],
    [token_id, filtered_pool_vote, u64_weights, sign_weights]
  );
}

// return reserve_y/reserve_x
export const getAvgPrice = (tradeRoute: TradeRoute | null): string => {
  if (!tradeRoute) return "0";
  const pools = tradeRoute.pools;
  let in_coin = tradeRoute.trade.in_coin;
  let k = 1;
  for (let i = 0; i < pools.length; i++) {
    const pool = pools[i];
    let reserve_in = 0;
    let reserve_out = 0;
    let in_decimals = 0;
    let out_decimals = 0;
    if (pool.x_coin_info.address === in_coin) {
      reserve_in = Number(pool.reserve_x);
      reserve_out = Number(pool.reserve_y);
      in_decimals = pool.x_coin_info.decimals;
      out_decimals = pool.y_coin_info.decimals;
      in_coin = pool.y_coin_info.address;
    } else if (pool.y_coin_info.address === in_coin) {
      reserve_in = Number(pool.reserve_y);
      reserve_out = Number(pool.reserve_x);
      in_decimals = pool.y_coin_info.decimals;
      out_decimals = pool.x_coin_info.decimals;
      in_coin = pool.x_coin_info.address;
    }
    k =
      ((k * reserve_out) / reserve_in) *
      Math.pow(10, in_decimals - out_decimals);
  }
  return k.toFixed(4);
};

// %
export function getPriceImpact(
  tradeRoute: TradeRoute,
  avgPrice: number
): string {
  const decimals = getDecimalsFromTradeRoute(tradeRoute);
  if (!decimals) return "";

  const coinOutDecimal = decimals[1];

  const avgOut =
    Number(avgPrice) *
    tradeRoute.trade.in_amount *
    Math.pow(10, coinOutDecimal);
  const expectedAmountOut =
    Number(getExpectedOut(tradeRoute)) * Math.pow(10, coinOutDecimal);

  const impact = (100 * (1 - Number(expectedAmountOut) / avgOut)).toFixed(2);
  return impact;
}

export function getAmountOut(
  amountIn: number,
  reserveIn: number,
  reserveOut: number
): number {
  const amountInWithFee = BigInt(amountIn) * BigInt(9975);
  const numerator = amountInWithFee * BigInt(reserveOut);
  const denominator =
    BigInt(reserveIn) * BigInt(10000) + BigInt(amountInWithFee);
  return parseInt((numerator / denominator).toString(), 10);
}

export function getAmountIn(
  amountOut: number,
  reserveIn: number,
  reserveOut: number
): number {
  const numerator = BigInt(reserveIn) * BigInt(amountOut) * BigInt(10000);
  const denominator = (BigInt(reserveOut) - BigInt(amountOut)) * BigInt(9975);
  return parseInt((numerator / denominator).toString(), 10) + 1;
}

export function getFeeAmount(tradeRoute: TradeRoute): number {
  if (tradeRoute.pools.length <= 0) return 0;
  return (
    tradeRoute.trade.in_amount * (1 - Math.pow(0.9975, tradeRoute.pools.length))
  );
}

export function getExpectedOut(tradeRoute: TradeRoute): string {
  const decimals = getDecimalsFromTradeRoute(tradeRoute);
  if (!decimals) return "0.0000";
  const outputAmount = getTradeOutputAmount(tradeRoute);

  return (outputAmount / Math.pow(10, decimals[1])).toFixed(4);
}

export function getExpectedIn(tradeRoute: TradeRoute): string {
  const decimals = getDecimalsFromTradeRoute(tradeRoute);
  if (!decimals) return "0.0000";
  const inputAmount = getTradeInputAmount(tradeRoute);
  return (inputAmount / Math.pow(10, decimals[0])).toFixed(4);
}

export function getMinimumReceived(
  tradeRoute: TradeRoute,
  slippage: number
): string {
  const outReceived = Number(getExpectedOut(tradeRoute));
  return (outReceived * (1 - slippage / 100)).toFixed(4);
}
export function getMaximumSold(
  tradeRoute: TradeRoute,
  slippage: number
): string {
  const inSold = Number(getExpectedOut(tradeRoute));

  return (inSold * (1 + slippage / 100)).toFixed(4);
}

export async function add_liquidity(
  fn: Function,
  coin_x: string,
  coin_y: string,
  amount_x: number,
  amount_y: number,
  amount_x_min: number,
  amount_y_min: number
) {
  return await submit(
    fn,
    `${foil_swap_address}::router::add_liquidity`,
    [coin_x, coin_y],
    [amount_x, amount_y, amount_x_min, amount_y_min]
  );
}

export async function remove_liquidity(
  fn: Function,
  coin_x: string,
  coin_y: string,
  amount: number,
  amount_x_min: number,
  amount_y_min: number
) {
  return await submit(
    fn,
    `${foil_swap_address}::router::remove_liquidity`,
    [coin_x, coin_y],
    [amount, amount_x_min, amount_y_min]
  );
}

export const create_gauge = async (fn: Function, x: string, y: string) => {
  let coinX = x;
  let coinY = y;
  if (x > y) {
    coinX = y;
    coinY = x;
  }
  return await submit(
    fn,
    `${foil_vesting_address}::foil::create_gauge`,
    [coinX, coinY],
    []
  );
};

export const gauge_deposit = async (
  fn: Function,
  coin: string,
  gauge_id: number,
  amount: number,
  token_id: number
) => {
  return await submit(
    fn,
    `${foil_vesting_address}::foil::gauge_deposit`,
    [coin],
    [gauge_id, amount, token_id]
  );
};

export const gauge_withdraw = async (
  fn: Function,
  coin: string,
  gauge_id: number,
  amount: number
) => {
  return await submit(
    fn,
    `${foil_vesting_address}::foil::gauge_withdraw`,
    [coin],
    [gauge_id, amount]
  );
};

export async function getPair(x: string, y: string) {
  const data = await getAccountResource(
    foil_swap_address,
    `${foil_swap_address}::swap::TokenPairReserve<${x},${y}>`
  );
  return data;
}

export async function get_current_lp(address: string) {
  const data = await getAccountResources(address);
  if (data && Array.isArray(data)) {
    const pairs = data?.filter((item: any) => {
      return (
        item.type.startsWith(
          `0x1::coin::CoinStore<${foil_swap_address}::swap::LPToken`
        ) && item.data.coin.value > 0
      );
    });
    // window.console.info(pairs);
    return pairs;
  } else {
    return [];
  }
}

export function get_coin_pair_by_lp(pair_lp: string) {
  const regexp = /,(?![^<>]*>)/;
  let a = pair_lp.replace(`${foil_swap_address}::swap::LPToken<`, "");
  a = a.substring(0, a.length - 1); //remove last >
  const s = a.split(regexp);
  return [s[0].trim(), s[1].trim()];
}

// export function get_coin_pair_by_pair(pair_type: string) {
export function get_coin_address_by_pair(pair_type: string): [string, string] {
  const regexp = /,(?![^<>]*>)/;
  let a = pair_type.replace(
    `${foil_swap_address}::swap::TokenPairReserve<`,
    ""
  );
  a = a.substring(0, a.length - 1); //remove last >
  const s = a.split(regexp);
  return [s[0].trim(), s[1].trim()];
}

export function get_coin_short_name(name: string) {
  return short_name(name);
}

export function get_coin_icon(name: string) {
  const coin = coins.filter((item) => {
    return item.address === name;
  });

  if (coin && coin[0]) {
    return { icon: coin[0].logoURI };
  }
  return { icon: APT_LOGO };
}

export async function get_all_pairs() {
  const data = await getAccountResources(foil_swap_address);
  if (data && Array.isArray(data)) {
    const pairs = data?.filter((item: any) => {
      // window.console.info(item.type);
      return item.type.startsWith(
        `${foil_swap_address}::swap::TokenPairReserve`
      );
    });
    // window.console.info(pairs);
    return pairs;
  } else {
    return [];
  }
}

export async function get_all_pools(): Promise<Pool[]> {
  const data = await getAccountResources(foil_swap_address);
  if (data && Array.isArray(data)) {
    const pairs = data?.filter((item: any) => {
      // window.console.info(item.type);
      return item.type.startsWith(
        `${foil_swap_address}::swap::TokenPairReserve`
      );
    });
    const pools = [];
    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i];
      const pair_type = pair.type;
      const [coin_address_x, coin_address_y] =
        get_coin_address_by_pair(pair_type);

      const x_coin_info = await getCoinInfo(coin_address_x);
      const y_coin_info = await getCoinInfo(coin_address_y);
      const pool: Pool = {
        reserve_x: (pair.data as any).reserve_x,
        reserve_y: (pair.data as any).reserve_y,
        x_coin_info,
        y_coin_info,
      };

      pools.push(pool);
    }
    // window.console.info(pairs);
    return pools;
  } else {
    return [];
  }
}

export async function get_lp_coin_balance_no_decimals(
  address: string,
  coinX: string,
  coinY: string
): Promise<number> {
  console.log(address);
  let x = coinX;
  let y = coinY;
  if (coinX > coinY) {
    x = coinY;
    y = coinX;
  }
  const coin = `${foil_swap_address}::swap::LPToken<${x}, ${y}>`;

  const amount = await getCoinBalanceNoDecimals(address, coin);
  // window.console.info('xy-a', amount);
  return amount;
}

//1 LPTOKEN
export async function get_lp_coin_balance(
  address: string,
  coinX: string,
  coinY: string
): Promise<string> {
  let x = coinX;
  let y = coinY;
  if (coinX > coinY) {
    x = coinY;
    y = coinX;
  }
  const coin = `${foil_swap_address}::swap::LPToken<${x}, ${y}>`;
  const amount = await getCoinBalance(address, coin);
  return amount;
}

export async function get_all_pairs_vote(
  my_address: string,
  token_id: number
): Promise<PoolVote[]> {
  const type = `${foil_vesting_address}::foil::VoterState`;
  const data: any = await getAccountResource(foil_vesting_address, type);

  const res_data: PoolVote[] = [];
  if (data) {
    const pools = await get_all_pools();
    const total_weight = parseInt(data.data.total_weight, 10);
    for (let i = 0; i < data.data.pools.length; i++) {
      const pool = data.data.pools[i];
      const [coin_address_x, coin_address_y] = get_coin_pair_by_lp(pool);
      const searched_pool = pools.find((pool) => {
        return (
          pool.x_coin_info.address === coin_address_x &&
          pool.y_coin_info.address === coin_address_y
        );
      });
      if (searched_pool) {
        const amountXY = await get_lp_coin_balance_no_decimals(
          my_address,
          searched_pool.x_coin_info.address,
          searched_pool.y_coin_info.address
        );
        const coin_info_supply = await get_coin_xy_supply(
          searched_pool.x_coin_info.address,
          searched_pool.y_coin_info.address
        );
        const share = amountXY / coin_info_supply;
        const pool_addr = `${foil_swap_address}::swap::LPToken<${searched_pool.x_coin_info.address}, ${searched_pool.y_coin_info.address}>`;
        const weight = await getVoteWeight(
          pool_addr,
          data.data.weights_map.handle
        );
        const gauge_id = await getGaugeId(
          pool_addr,
          data.data.gauges_map.handle
        );

        const bribe_type = `${foil_vesting_address}::foil::BribeState`;
        const bribe_data: any = await getAccountResource(
          foil_vesting_address,
          bribe_type
        );
        const bribe_handle = bribe_data.data.bribe_map.handle;
        const reward_amounts = await getRewardAmounts(gauge_id, bribe_handle);
        let my_votes = 0;
        if (token_id > 0) {
          my_votes = await getMyVotes(
            pool_addr,
            token_id,
            data.data.votes_map.handle
          );
        }

        res_data.push({
          pool_addr,
          pool: searched_pool,
          my_votes: my_votes.toFixed(2),
          my_votes_percent:
            total_weight === 0
              ? "0.00"
              : ((my_votes * 100) / total_weight).toFixed(2),
          my_x_balance: getDecimalsAmount(
            Number(searched_pool.reserve_x) * share,
            searched_pool.x_coin_info.decimals
          ),
          my_y_balance: getDecimalsAmount(
            Number(searched_pool.reserve_y) * share,
            searched_pool.y_coin_info.decimals
          ),
          weight,
          weight_percent:
            total_weight === 0
              ? "0"
              : ((weight * 100) / total_weight).toFixed(2),
          reward_amounts,
        } as PoolVote);
      }
    }
  }
  return res_data;
}

export async function get_coin_xy_info(coinX: string, coinY: string) {
  let x = coinX;
  let y = coinY;
  if (coinX > coinY) {
    x = coinY;
    y = coinX;
  }
  return await get_coin_info(
    foil_swap_address,
    `${foil_swap_address}::swap::LPToken<${x}, ${y}>`
  );
}

export async function get_coin_xy_supply(
  coinX: string,
  coinY: string
): Promise<number> {
  const info: any = await get_coin_xy_info(coinX, coinY);
  if (!info) {
    return 0;
  }
  return info.data.supply.vec[0].integer.vec[0].value;
}

export function getDecimalsAmount(amount: number, decimal = 6, fixed = 3) {
  return (amount / Math.pow(10, decimal)).toFixed(fixed);
}

export function getIntAmountFromDecimals(amount: number, decimal = 6) {
  return parseInt((amount * Math.pow(10, decimal)).toFixed(0), 10);
}

export const routeList = (
  pairs: Pool[],
  startPoint: string,
  endPoint: string,
  maxHop: number,
  currentPairs: Pool[],
  nextStartPoint: string,
  routes: Pool[][]
) => {
  if (!(pairs.length > 0)) {
    return;
  }
  if (!(maxHop > 0)) {
    return;
  }

  if (!(startPoint === nextStartPoint || currentPairs.length > 0)) {
    return;
  }

  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i];
    if (
      pair.x_coin_info.address !== nextStartPoint &&
      pair.y_coin_info.address !== nextStartPoint
    )
      continue;
    if (
      currentPairs.length > 0 &&
      (pair.x_coin_info.address === startPoint ||
        pair.y_coin_info.address === startPoint)
    )
      continue;
    if (
      parseInt(pair.reserve_x!, 10) === 0 ||
      parseInt(pair.reserve_y!, 10) === 0
    )
      continue;

    let tempEndPoint = "";
    if (pair.x_coin_info.address === nextStartPoint) {
      tempEndPoint = pair.y_coin_info.address;
    } else if (pair.y_coin_info.address === nextStartPoint) {
      tempEndPoint = pair.x_coin_info.address;
    }

    if (
      pair.x_coin_info.address === endPoint ||
      pair.y_coin_info.address === endPoint
    ) {
      routes.push([...currentPairs, pair]);
    } else if (maxHop > 1 && pairs.length > 1) {
      const pairsExcludingThisPair = pairs
        .slice(0, i)
        .concat(pairs.slice(i + 1, pairs.length));
      routeList(
        pairsExcludingThisPair,
        startPoint,
        endPoint,
        maxHop - 1,
        [...currentPairs, pair],
        tempEndPoint,
        routes
      );
    }
  }
};

export const getTradeOutputAmount = (tradeRoute: TradeRoute): number => {
  if (tradeRoute.pools.length < 1) return 0;
  const decimals = getDecimalsFromTradeRoute(tradeRoute);
  if (!decimals) return 0;
  let amountIn = tradeRoute.trade.in_amount * Math.pow(10, decimals[0]);
  let in_coin = tradeRoute.trade.in_coin;
  for (let i = 0; i < tradeRoute.pools.length; i++) {
    const pool = tradeRoute.pools[i];
    let reserve_in = 0;
    let reserve_out = 0;
    if (pool.x_coin_info.address === in_coin) {
      reserve_in = Number(pool.reserve_x);
      reserve_out = Number(pool.reserve_y);
      in_coin = pool.y_coin_info.address;
    } else if (pool.y_coin_info.address === in_coin) {
      reserve_in = Number(pool.reserve_y);
      reserve_out = Number(pool.reserve_x);
      in_coin = pool.x_coin_info.address;
    }
    amountIn = getAmountOut(amountIn, reserve_in, reserve_out);
  }
  return amountIn;
};

export const getTradeInputAmount = (tradeRoute: TradeRoute): number => {
  if (tradeRoute.pools.length < 1) return 0;
  const decimals = getDecimalsFromTradeRoute(tradeRoute);
  if (!decimals) return 0;
  let amountOut = tradeRoute.trade.out_amount * Math.pow(10, decimals[1]);
  let out_coin = tradeRoute.trade.out_coin;
  for (let i = tradeRoute.pools.length - 1; i >= 0; i--) {
    const pool = tradeRoute.pools[i];
    let reserve_in = 0;
    let reserve_out = 0;
    if (pool.x_coin_info.address === out_coin) {
      reserve_in = Number(pool.reserve_y);
      reserve_out = Number(pool.reserve_x);
      out_coin = pool.y_coin_info.address;
    } else if (pool.y_coin_info.address === out_coin) {
      reserve_in = Number(pool.reserve_x);
      reserve_out = Number(pool.reserve_y);
      out_coin = pool.x_coin_info.address;
    }
    amountOut = getAmountIn(amountOut, reserve_in, reserve_out);
  }
  return amountOut;
};

export const getBestTradeRouteOut = (
  routes: Pool[][],
  trade: Trade
): Pool[] | null => {
  if (routes.length < 1) {
    return null;
  }
  let bestRoute = routes[0];
  let bestTradeInAmount = getTradeInputAmount({ pools: routes[0], trade });
  for (let i = 1; i < routes.length; i++) {
    const route = routes[i];
    const tradeInAmount = getTradeInputAmount({ pools: routes[0], trade });
    if (tradeInAmount < bestTradeInAmount) {
      bestTradeInAmount = tradeInAmount;
      bestRoute = route;
    }
  }
  return bestRoute;
};

export const getBestTradeRoute = (
  routes: Pool[][],
  trade: Trade
): Pool[] | null => {
  if (routes.length < 1) {
    return null;
  }
  let bestRoute = routes[0];
  let bestTradeOutputAmount = getTradeOutputAmount({ pools: routes[0], trade });
  for (let i = 1; i < routes.length; i++) {
    const route = routes[i];
    const tradeOutputAmount = getTradeOutputAmount({ pools: routes[0], trade });
    if (tradeOutputAmount > bestTradeOutputAmount) {
      bestTradeOutputAmount = tradeOutputAmount;
      bestRoute = route;
    }
  }
  return bestRoute;
};

//in_decimal, out_decimal
export const getDecimalsFromTradeRoute = (
  tradeRoute: TradeRoute
): [number, number] | null => {
  if (tradeRoute.pools.length < 1) return null;
  const in_coin = tradeRoute.trade.in_coin;
  const out_coin = tradeRoute.trade.out_coin;
  let in_decimal = 0;
  let out_decimal = 0;
  if (tradeRoute.pools[0].x_coin_info.address === in_coin) {
    in_decimal = tradeRoute.pools[0].x_coin_info.decimals;
  } else if (tradeRoute.pools[0].y_coin_info.address === in_coin) {
    in_decimal = tradeRoute.pools[0].y_coin_info.decimals;
  }

  if (
    tradeRoute.pools[tradeRoute.pools.length - 1].x_coin_info.address ===
    out_coin
  ) {
    out_decimal =
      tradeRoute.pools[tradeRoute.pools.length - 1].x_coin_info.decimals;
  } else if (
    tradeRoute.pools[tradeRoute.pools.length - 1].y_coin_info.address ===
    out_coin
  ) {
    out_decimal =
      tradeRoute.pools[tradeRoute.pools.length - 1].y_coin_info.decimals;
  }
  return [in_decimal, out_decimal];
};

//in_symbol, out_symbol
export const getSymbolsFromTradeRoute = (
  tradeRoute: TradeRoute
): [string, string] | null => {
  if (tradeRoute.pools.length < 1) return null;
  const in_coin = tradeRoute.trade.in_coin;
  const out_coin = tradeRoute.trade.out_coin;
  let in_symbol = "";
  let out_symbol = "";
  if (tradeRoute.pools[0].x_coin_info.address === in_coin) {
    in_symbol = tradeRoute.pools[0].x_coin_info.symbol;
  } else if (tradeRoute.pools[0].y_coin_info.address === in_coin) {
    in_symbol = tradeRoute.pools[0].y_coin_info.symbol;
  }

  if (
    tradeRoute.pools[tradeRoute.pools.length - 1].x_coin_info.address ===
    out_coin
  ) {
    out_symbol =
      tradeRoute.pools[tradeRoute.pools.length - 1].x_coin_info.symbol;
  } else if (
    tradeRoute.pools[tradeRoute.pools.length - 1].y_coin_info.address ===
    out_coin
  ) {
    out_symbol =
      tradeRoute.pools[tradeRoute.pools.length - 1].y_coin_info.symbol;
  }
  return [in_symbol, out_symbol];
};

//in_symbol, out_symbol
export const getRouteStringFromTradeRoute = (
  tradeRoute: TradeRoute
): string => {
  if (tradeRoute.pools.length < 1) return "";
  let in_coin = tradeRoute.trade.in_coin;
  let in_symbol = "";
  let out_symbol = "";
  let res: string = "";
  for (let i = 0; i < tradeRoute.pools.length; i++) {
    if (tradeRoute.pools[i].x_coin_info.address === in_coin) {
      in_coin = tradeRoute.pools[i].y_coin_info.address;
      in_symbol = tradeRoute.pools[i].x_coin_info.symbol;
      out_symbol = tradeRoute.pools[i].y_coin_info.symbol;
    } else {
      in_coin = tradeRoute.pools[i].x_coin_info.address;
      in_symbol = tradeRoute.pools[i].y_coin_info.symbol;
      out_symbol = tradeRoute.pools[i].x_coin_info.symbol;
    }
    res = `${res}${in_symbol} > `;
  }
  res = `${res}${out_symbol}`;
  return res;
};
